import React, { useEffect, useRef, useState } from "react";
import useFreeTrial from "../../hooks/useFreeTrial";
import { Link } from "@reach/router";

export default function LandingOnlineHero() {
  const [showAnimation, setShowAnimation] = useState(false);
  const { handleFreeTrial } = useFreeTrial();

  useEffect(() => {
    setTimeout(() => {
      setShowAnimation(true);
    }, 100);
  }, []);

  return (
    <div id="onlineHero" className="container-fluid px-0">
      {/*<div className="online-hero-overlay"></div>*/}
      <video
        className="mw-100 w-100"
        style={{ height: "600px", objectFit: "cover" }}
        playsInline
        autoPlay
        muted
        loop
      >
        <source
          src={
            "https://thebodymethod.s3.us-west-1.amazonaws.com/tbmonline-landing-video.mp4"
          }
          type="video/mp4"
        />
      </video>

      <div className="online-hero__content ">
        <h1  className={`online-hero__title ${
            showAnimation ? "animate-fade-in" : "opacity-0"
          }`}>
          Nuestro método, en tu espacio y a tus tiempos
        </h1>
        <p className={`online-hero__desc ${
            showAnimation ? "animate-fade-in" : "opacity-0"}`}>
           Una plataforma con diferentes disciplinas para acompañarte en tu proceso, ayudarte a lograr tus objetivos y fortalecer tu conexión contigo misma a través del movimiento.
        </p>

        <div    className={`content__ctas d-flex justify-content-center gap-4 align-items-center ${
            showAnimation ? "animate-fade-in" : "opacity-0"
          }`}>
          <button onClick={handleFreeTrial} type="button" className="btn btn-primary">
            Pruébalo 7 días gratis
          </button>
          <Link to="/pages/workout-planner" className="btn btn-light">
            Conoce tu plan ideal
          </Link>
        </div>
      </div>
    </div>
  );
}
